<template>
  <v-dialog
    v-model="dialog"
    width="500px"
    style="z-index: 9999;"
  >
    <v-card>
      <v-toolbar dense elevation="0">
        <v-toolbar-title>{{ $t("dialog.identification.title") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn @click="addEvent" elevation="0" color="primary">
          {{ $t("dialog.identification.add") }}
        </v-btn>
        <v-btn icon @click="dialog=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider class="mx-2" />

      <v-container class="pb-6">
        <validation-observer ref="form_validation">
          <form @submit.prevent="submit">
            <validation-provider
              v-slot="{ errors }"
              name="dialog.identification.type"
              rules="required"
            >
              <v-select
                v-model="type"
                :items="getIdentifications"
                item-text="code"
                :label="$t('dialog.identification.type')"
                :error-messages="errors"
              >
                <template v-slot:selection="data">
                  {{ data.item.name }}
                </template>
                <template v-slot:item="data">
                  {{ data.item.name }}
                </template>
              </v-select>
            </validation-provider>

            <validation-provider
              v-slot="{ errors }"
              name="dialog.identification.code"
              rules="required|max:50"
            >
              <v-text-field
                v-model="code"
                :error-messages="errors"
                :counter="50"
                :label="$t('dialog.identification.code')"
                required
              ></v-text-field>
            </validation-provider>
          </form>
        </validation-observer>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "IdentificationDialog",

  props: {
    filter: {
      type: String,
      default: "all"
    },
    ids: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      dialog: false,
      type: null,
      code: null
    };
  },
  methods: {
    open() {
      this.type = null;
      this.code = null;
      this.dialog = true;
      if (this.$refs.form_validation !== undefined)
        this.$refs.form_validation.reset();
    },

    async addEvent() {
      if (await this.$refs.form_validation.validate()) {
        // TODO: pridat konrolu duplicity v ids
        this.$emit("added", this.type, this.code.trim());
        this.dialog = false;
      }
    }
  },
  computed: {
    getIdentifications() {
      if (this.filter === "person")
        return this.$store.state.data.listIdentifications.filter(x => x.forPerson === true);
      else if (this.filter === "vehicle")
        return this.$store.state.data.listIdentifications.filter(x => x.forVehicle === true);
      else
        return this.$store.state.data.listIdentifications;
    }
  },

  mounted() {
    this.$store.dispatch("data/fetchCodes", "identifications");
  }
};
</script>